import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Tab,
  TableCell,
  Tabs,
  TextField,
  ClickAwayListener,
} from '@material-ui/core'
import { useEffect, useState, useMemo } from 'react'
import { X } from 'react-feather'
import { useTranslation } from 'react-i18next'
import LoadingWrapper from '../../components/LoadingWrapper'
import BombotTagsManagement from '../../components/TagsManagementModal/BombotTagsManagement'
import FbTagsManagement from '../../components/TagsManagementModal/FbTagsManagement'
import MainLayout from '../MainLayout'
import { Autocomplete } from '@material-ui/lab'
import MessengerButton from '../Home/items/MessengerButton'
import { useDispatch, useSelector } from 'react-redux'
import { getFanpageDetail } from '../Fanpage/FanpageActions'
import Tour from 'reactour'
import {
  getIsGuideByKey,
  GUIDE_TYPE_ENUM,
  setIsGuideByKey,
} from '../../utils/helper'
import { selectGuideListByKey } from '../../stores/config/config.selector'
import { Warning } from '@material-ui/icons'
import _ from 'lodash'
import styles from './TagView.module.scss'

const useStyles = makeStyles({
  widthCheckBox: {
    minWidth: '60px',
    width: '4%',
  },
  widthSeq: {
    minWidth: '80px',
    padding: '0 8px !important',
  },
  widthId: {
    minWidth: '120px',
    padding: '0 8px !important',
  },
  widthName: {
    minWidth: '220px',
    padding: '0 8px !important',
  },
  widthCreatedAt: {
    minWidth: '220px',
    padding: '0 8px !important',
  },
  widthCreatedBy: {
    minWidth: '220px',
    padding: '0 8px !important',
  },
  widthQuantityCus: {
    minWidth: '120px',
    padding: '0 8px !important',
  },
  widthActions: {
    minWidth: '140px',
    width: '6%',
    padding: '0 8px !important',
  },
  p0: {
    padding: '0',
    margin: '0',
  },
  heightHeader: {
    height: '52px',
  },
  f600: {
    fontWeight: 600,
  },
  checkBoxPadding: {
    padding: '10px 20px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  closeBtn: {
    color: '#ffffff',
    backgroundColor: '#dc3545',
    border: '2px solid #dc3545',
    padding: '6px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#c82333',
      borderColor: '#bd2130',
    },
  },
  submitBtn: {
    color: 'white',
    backgroundColor: '#28a745',
    border: '2px solid #28a745',
    padding: '6px 26px',
    borderRadius: '4px',
    cursor: 'pointer',
    margin: '0 36px !important',
    '&:hover': {
      backgroundColor: '#218838',
      borderColor: '#1e7e34',
    },
  },
  numCusInp: {
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  footerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0 26px',
    margin: '12px 0',
    minHeight: '48px',
  },
  container: {
    flex: 1,
    width: '100%',
  },
  paginationBottom: {
    display: 'flex !important',
    justifyContent: 'end !important',
    alignItems: 'center !important',
  },
  buttonLoadMore: {
    alignItems: 'center',
    appearance: 'none',
    backgroundColor: '#fff',
    border: '1px solid #dbdbdb',
    borderRadius: '.375em',
    boxShadow: 'none',
    boxSizing: 'border-box',
    color: '#363636',
    cursor: 'pointer',
    display: 'inline-flex',
    fontFamily: `BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`,
    fontSize: '0.8rem',
    height: '1.8em',
    justifyContent: 'center',
    lineHeight: '1.5',
    padding: 'calc(.5em - 1px) 1em',
    position: 'relative',
    textAlign: 'center',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    touchAction: 'manipulation',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: '#b5b5b5',
    },
    '&:active': {
      borderColor: '#4a4a4a',
      outline: '0',
    },
    '&:focus': {
      borderColor: '#485fc7',
      outline: '0',
    },
    '&:focus:not(:active)': {
      boxShadow: 'rgba(72, 95, 199, 0.25) 0 0 0 0.125em',
    },
  },
  rowItem: {
    cursor: 'pointer',
  },

  noData: {
    color: 'rgba(0,0,0,.5)',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '24px',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#637381',
    padding: '8px',
    marginRight: '8px',
    '&:hover': {
      color: '#212B36',
      backgroundColor: 'rgba(99, 115, 129, 0.08)',
      borderRadius: '50%',
    },
  },
  dialogTitle: {
    position: 'relative',
    paddingRight: '48px',
    margin: 0,
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

export const tagType = {
  BOMBOT_TAGS: 'BOMBOT_TAGS',
  FACEBOOK_TAGS: 'FACEBOOK_TAGS',
}

const TagView = ({
  onFanpageSelected,
  fanpageSelected,
  fanpageFull,
  getData,
  getFanpage,
}) => {
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(false)
  const [tabVal, setTabVal] = useState(tagType.BOMBOT_TAGS)

  const [selectedPageId, setSelectedPageId] = useState(
    fanpageSelected.id || null
  )

  const [bombotStats, setBombotStats] = useState({ total: 0, used: 0, empty: 0, system: 0 });
  const [fbStats, setFbStats] = useState({ total: 0, used: 0, empty: 0 });

  const [bombotFilter, setBombotFilter] = useState('ALL');
  const [fbFilter, setFbFilter] = useState('ALL');

  const [comboOpen, setComboOpen] = useState(false);
  const [comboSearch, setComboSearch] = useState('');

  const filteredFanpages = useMemo(() => {
    if (!comboSearch.trim()) return fanpageFull || [];
    const lower = comboSearch.toLowerCase();
    return (fanpageFull || []).filter(p => p.name?.toLowerCase().includes(lower));
  }, [fanpageFull, comboSearch]);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleChangeFanpage = (key, value) => {
    switch (key) {
      case 'fanpage':
        if (value) {
          onFanpageSelected(value);
          dispatch(getFanpageDetail(value.id));
        }
        break;
      default:
        break;
    }
  };

  // Gọi getFanpage một lần khi mount
  useEffect(() => {
    getFanpage({});
  }, []);

  // Đổi fanpage thì xoá số cũ, chờ statistic của fanpage mới
  useEffect(() => {
    setBombotStats({ total: 0, used: 0, empty: 0, system: 0 });
    setFbStats({ total: 0, used: 0, empty: 0 });
  }, [fanpageSelected?.id]);

  const tourOverview = useSelector(
    selectGuideListByKey(GUIDE_TYPE_ENUM.tag_manager)
  )

  const [tourConfig, setTourConfig] = useState(null)

  useEffect(() => {
    console.log('fanpageSelected ==>', fanpageSelected)
    if (_.isEmpty(fanpageSelected)) return

    if (getIsGuideByKey(GUIDE_TYPE_ENUM.tag_manager) && tourOverview?.length) {
      console.log('[TagView] tour tag_manager steps RAW:', JSON.stringify(tourOverview))
      // Override selector + nội dung tooltip để khớp với UI hiện tại
      const stepOverrides = {
        '#select-fanpage':     { selector: '#tag_search',         content: t('tag_page.tour_search') },
        '#tag_fanpage_select': { selector: '#tag_fanpage_select', content: t('tag_page.tour_fanpage_select') },
        '#fanpage_select':     { selector: '#tag_search',         content: t('tag_page.tour_search') },
        '#tag_search':         { selector: '#tag_search',         content: t('tag_page.tour_search') },
        '#tag_bombot_tab':     { selector: '#tag_bombot_tab',     content: t('tag_page.tour_bombot_tab') },
        '#tag_fb_tab':         { selector: '#tag_fb_tab',         content: t('tag_page.tour_fb_tab') },
        '#tag_filter_all':     { selector: '#tag_filter_all',     content: t('tag_page.tour_filter') },
      }
      const mappedSteps = tourOverview.map((step) => {
        const override = stepOverrides[step.selector]
        if (override) {
          console.log(`[TagView] Override step: ${step.selector} → ${override.selector}`, override)
          return { ...step, ...override }
        }
        console.log(`[TagView] Keep original step:`, step.selector)
        return step
      })
      console.log('[TagView] tour tag_manager steps MAPPED:', JSON.stringify(mappedSteps))
      setTourConfig(mappedSteps)
      setIsGuideByKey(GUIDE_TYPE_ENUM.tag_manager)
    }
  }, [tourOverview, fanpageSelected])

  return (
    <MainLayout>
      <Tour
        steps={tourConfig}
        isOpen={tourConfig != null}
        closeWithMask={false}
        lastStepNextButton={
          <Button size="small" className="btn--rounder" variant="contained">
            {t('common.btn.close')}
          </Button>
        }
        accentColor="#05ae34"
        onRequestClose={() => setTourConfig(null)}
      />

      <LoadingWrapper isOpen={isLoading}>
        {/* V3 Page Head */}
        <div className={styles.pageHead}>
          <div>
            <div className={styles.pageTitle}>{t('tag_page.page_title')}</div>
            <div className={styles.pageSub}>{t('tag_page.page_sub')}</div>
          </div>
          <div id="tag_fanpage_select" className={styles.fanpageCombo}>
            <span className={styles.fanpageComboLbl}>Fanpage</span>
            <ClickAwayListener onClickAway={() => setComboOpen(false)}>
              <div className={styles.comboWrap}>
                <button
                  id="fanpage_select"
                  className={`${styles.comboBtn} ${comboOpen ? styles.open : ''}`}
                  onClick={() => setComboOpen(!comboOpen)}
                >
                  <span>{fanpageSelected?.name ? `${fanpageSelected.name} · ${bombotStats.total + fbStats.total} tag` : t('tag_page.select_fanpage')}</span>
                  <svg viewBox="0 0 12 12" fill="none"><path d="M3 5l3 3 3-3"/></svg>
                </button>
                <div className={`${styles.comboPop} ${comboOpen ? styles.show : ''}`}>
                  <div className={styles.comboSearch}>
                    <svg viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="4.5"/><path d="M13.5 13.5l-3-3"/></svg>
                    <input
                      type="text"
                      placeholder={t('tag_page.search_fanpage')}
                      value={comboSearch}
                      onChange={(e) => setComboSearch(e.target.value)}
                    />
                  </div>
                  <div className={styles.comboList}>
                    {filteredFanpages.length > 0 ? (
                      filteredFanpages.map(page => (
                        <div
                          key={page.id}
                          className={`${styles.comboOpt} ${selectedPageId === page.id ? styles.selected : ''}`}
                          onClick={() => {
                            setSelectedPageId(page.id);
                            handleChangeFanpage('fanpage', page);
                            setComboOpen(false);
                            setComboSearch('');
                          }}
                        >
                          <svg className={styles.comboCheck} viewBox="0 0 14 14" fill="none"><path d="M2.5 7l3 3 6-6" strokeLinecap="round" strokeLinejoin="round"/></svg>
                          {page.name}
                          <span className={styles.comboOptCount}>
                            {selectedPageId === page.id
                              ? `${bombotStats.total + fbStats.total} tag`
                              : ''}
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className={styles.comboEmpty}>{t('tag_page.no_fanpage_found')}</div>
                    )}
                  </div>
                </div>
              </div>
            </ClickAwayListener>
          </div>
        </div>

        {selectedPageId ? (
          <>
            {/* KPI Row */}
            <div className={styles.kpiRow}>
              {tabVal === tagType.BOMBOT_TAGS ? (
                <>
                  <div
                    className={`${styles.kpiCard} ${bombotFilter === 'ALL' ? styles.selected : ''}`}
                    onClick={() => setBombotFilter('ALL')}
                  >
                    <div className={styles.kpiTop}>
                      <div className={`${styles.kpiIcon} ${styles.iTotal}`}>
                        <svg viewBox="0 0 16 16" fill="none"><path d="M2 2h5l6 6-5 5-6-6V2z"/><circle cx="5" cy="5" r="1"/></svg>
                      </div>
                      <span className={styles.kpiHint}>{bombotFilter === 'ALL' ? t('tag_page.kpi_filtering') : t('tag_page.kpi_click_filter')}</span>
                    </div>
                    <div className={styles.kpiVal}>{bombotStats.total.toLocaleString("vi-VN")}</div>
                    <div className={styles.kpiLbl}>{t('tag_page.kpi_total_bombot')}</div>
                  </div>
                  <div
                    className={`${styles.kpiCard} ${bombotFilter === 'ACTIVE' ? styles.selected : ''}`}
                    onClick={() => setBombotFilter('ACTIVE')}
                  >
                    <div className={styles.kpiTop}>
                      <div className={`${styles.kpiIcon} ${styles.iActive}`}>
                        <svg viewBox="0 0 16 16" fill="none"><circle cx="6" cy="6" r="2.3"/><path d="M2 13.5c0-2.2 1.8-3.8 4-3.8s4 1.6 4 3.8"/><path d="M10.2 2.4a2.3 2.3 0 010 4.5M13.5 13.5c0-1.9-1.1-3.3-2.6-3.8"/></svg>
                      </div>
                      <span className={styles.kpiHint}>{bombotFilter === 'ACTIVE' ? t('tag_page.kpi_filtering') : t('tag_page.kpi_click_filter')}</span>
                    </div>
                    <div className={styles.kpiVal}>{bombotStats.used.toLocaleString("vi-VN")}</div>
                    <div className={styles.kpiLbl}>{t('tag_page.kpi_active')}</div>
                  </div>
                  <div
                    className={`${styles.kpiCard} ${bombotStats.empty > 0 ? styles.kpiWarn : ""} ${bombotFilter === 'EMPTY' ? styles.selected : ''}`}
                    onClick={() => setBombotFilter('EMPTY')}
                  >
                    <div className={styles.kpiTop}>
                      <div className={`${styles.kpiIcon} ${styles.iEmpty}`}>
                        <svg viewBox="0 0 16 16" fill="none"><path d="M8 1.5L1.5 13h13L8 1.5z"/><path d="M8 6.5v3M8 11.5h.01"/></svg>
                      </div>
                      <span className={styles.kpiHint}>{bombotFilter === 'EMPTY' ? t('tag_page.kpi_filtering') : t('tag_page.kpi_click_filter')}</span>
                    </div>
                    <div className={styles.kpiVal}>{bombotStats.empty.toLocaleString("vi-VN")}</div>
                    <div className={styles.kpiLbl}>{t('tag_page.kpi_empty')}</div>
                  </div>
                  <div
                    className={`${styles.kpiCard} ${bombotFilter === 'SYSTEM' ? styles.selected : ''}`}
                    onClick={() => setBombotFilter('SYSTEM')}
                  >
                    <div className={styles.kpiTop}>
                      <div className={`${styles.kpiIcon} ${styles.iSys}`}>
                        <svg viewBox="0 0 16 16" fill="none"><rect x="2" y="3" width="12" height="10" rx="2"/><path d="M5.5 8h5"/></svg>
                      </div>
                      <span className={styles.kpiHint}>{bombotFilter === 'SYSTEM' ? t('tag_page.kpi_filtering') : t('tag_page.kpi_click_filter')}</span>
                    </div>
                    <div className={styles.kpiVal}>{bombotStats.system.toLocaleString("vi-VN")}</div>
                    <div className={styles.kpiLbl}>{t('tag_page.kpi_system')}</div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={`${styles.kpiCard} ${fbFilter === 'ALL' ? styles.selected : ''}`}
                    onClick={() => setFbFilter('ALL')}
                  >
                    <div className={styles.kpiTop}>
                      <div className={`${styles.kpiIcon} ${styles.iTotal}`}>
                        <svg viewBox="0 0 16 16" fill="none"><path d="M2 2h5l6 6-5 5-6-6V2z"/><circle cx="5" cy="5" r="1"/></svg>
                      </div>
                      <span className={styles.kpiHint}>{fbFilter === 'ALL' ? t('tag_page.kpi_filtering') : t('tag_page.kpi_click_filter')}</span>
                    </div>
                    <div className={styles.kpiVal}>{fbStats.total.toLocaleString("vi-VN")}</div>
                    <div className={styles.kpiLbl}>{t('tag_page.kpi_total_fb')}</div>
                  </div>
                  <div
                    className={`${styles.kpiCard} ${fbFilter === 'ACTIVE' ? styles.selected : ''}`}
                    onClick={() => setFbFilter('ACTIVE')}
                  >
                    <div className={styles.kpiTop}>
                      <div className={`${styles.kpiIcon} ${styles.iActive}`}>
                        <svg viewBox="0 0 16 16" fill="none"><circle cx="6" cy="6" r="2.3"/><path d="M2 13.5c0-2.2 1.8-3.8 4-3.8s4 1.6 4 3.8"/><path d="M10.2 2.4a2.3 2.3 0 010 4.5M13.5 13.5c0-1.9-1.1-3.3-2.6-3.8"/></svg>
                      </div>
                      <span className={styles.kpiHint}>{fbFilter === 'ACTIVE' ? t('tag_page.kpi_filtering') : t('tag_page.kpi_click_filter')}</span>
                    </div>
                    <div className={styles.kpiVal}>{fbStats.used.toLocaleString("vi-VN")}</div>
                    <div className={styles.kpiLbl}>{t('tag_page.kpi_active')}</div>
                  </div>
                  <div
                    className={`${styles.kpiCard} ${fbStats.empty > 0 ? styles.kpiWarn : ""} ${fbFilter === 'EMPTY' ? styles.selected : ''}`}
                    onClick={() => setFbFilter('EMPTY')}
                  >
                    <div className={styles.kpiTop}>
                      <div className={`${styles.kpiIcon} ${styles.iEmpty}`}>
                        <svg viewBox="0 0 16 16" fill="none"><path d="M8 1.5L1.5 13h13L8 1.5z"/><path d="M8 6.5v3M8 11.5h.01"/></svg>
                      </div>
                      <span className={styles.kpiHint}>{fbFilter === 'EMPTY' ? t('tag_page.kpi_filtering') : t('tag_page.kpi_click_filter')}</span>
                    </div>
                    <div className={styles.kpiVal}>{fbStats.empty.toLocaleString("vi-VN")}</div>
                    <div className={styles.kpiLbl}>{t('tag_page.kpi_empty')}</div>
                  </div>
                  <div className={`${styles.kpiCard} ${styles.kpiStatic}`}>
                    <div className={styles.kpiTop}>
                      <div className={`${styles.kpiIcon} ${styles.iSync}`}>
                        <svg viewBox="0 0 16 16" fill="none"><path d="M13 3.5h-9a2 2 0 00-2 2v5a2 2 0 002 2h9a2 2 0 002-2v-5a2 2 0 00-2-2zM6 8l4-2.5v5L6 8z"/></svg>
                      </div>
                    </div>
                    <div className={styles.kpiVal}>{t('tag_page.kpi_sync_auto')}</div>
                    <div className={styles.kpiLbl}>{t('tag_page.kpi_sync_last')}</div>
                  </div>
                </>
              )}
            </div>

            <div className={styles.card}>
              <div className={styles.cardHd}>
                <div className={styles.segGroup}>
                  <div
                    id="tag_bombot_tab"
                    className={`${styles.segBtn} ${tabVal === tagType.BOMBOT_TAGS ? styles.active : ''}`}
                    onClick={() => setTabVal(tagType.BOMBOT_TAGS)}
                  >
                    {t('tag_page.tab_bombot')} <span className={styles.segCount}>{bombotStats.total}</span>
                  </div>
                  <div
                    id="tag_fb_tab"
                    className={`${styles.segBtn} ${tabVal === tagType.FACEBOOK_TAGS ? styles.active : ''}`}
                    onClick={() => setTabVal(tagType.FACEBOOK_TAGS)}
                  >
                    {t('tag_page.tab_facebook')} <span className={styles.segCount}>{fbStats.total}</span>
                  </div>
                </div>
                {tabVal === tagType.FACEBOOK_TAGS && (
                  <div className={styles.fbNote}>
                    <svg viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5"/><path d="M8 7.5v3.5M8 5h.01"/></svg>
                    {t('tag_page.fb_note')}
                  </div>
                )}
              </div>

              <div style={{ display: tabVal === tagType.BOMBOT_TAGS ? 'block' : 'none' }}>
                <BombotTagsManagement
                  getData={getData}
                  getFanpage={getFanpage}
                  setIsLoading={setIsLoading}
                  onDataLoad={setBombotStats}
                  filter={bombotFilter}
                  onFilterChange={setBombotFilter}
                />
              </div>

              <div style={{ display: tabVal === tagType.FACEBOOK_TAGS ? 'block' : 'none' }}>
                <FbTagsManagement
                  getData={getData}
                  getFanpage={getFanpage}
                  onDataLoad={setFbStats}
                  filter={fbFilter}
                  onFilterChange={setFbFilter}
                />
              </div>
            </div>
          </>
        ) : (
          <div
            style={{
              width: '100%',
              height: '70vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              overflow: 'hidden',
            }}
          >
            <img
              src="image/bgd-404.svg"
              alt="no selected fanpage"
              style={{
                width: "10%",
                height: "auto",
                objectFit: "contain",
                paddingTop: "12px",
                paddingBottom: "12px",
              }}
            />
            <p style={{ fontSize: '20px', lineHeight: '30px', fontWeight: 700, color: '#333', margin: 0 }}>
              {t('tag_page.empty_no_fanpage')}
            </p>
            <p style={{ fontSize: '14px', lineHeight: '22px', fontWeight: 400, color: '#333', margin: 0 }}>
              {t('tag_page.empty_no_fanpage_sub')}
            </p>
          </div>
        )}
      </LoadingWrapper>
      <MessengerButton />
    </MainLayout>
  )
}

export default TagView
